import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Label } from 'reactstrap';
import * as Accounts from '../store/Accounts';
import * as Records from '../store/Records';
import * as utility from '../data/Utility';

const unassigned = "{unassigned}";

class MdOverreadAssigned extends React.Component {
    constructor(props) {
        super(props);

        const createRecord = utility.propCheck(props.createRecord, false);
        const disabled = utility.propCheck(props.disabled, false);
        this.state = {
            assignedName: unassigned,
            createRecord: createRecord,
            disabled: disabled,
            dropdownOpen: false,
            overreadFetched: false,
            physiciansFetched: false
        }

        this.getAssignedList = this.getAssignedList.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps) {
        this.initialize();

        var prevRecord = null;
        if (prevProps != null) {
            prevRecord = prevProps.recordsState.record;

            if (prevProps.disabled !== this.props.disabled) {
                this.setState({
                    disabled: this.props.disabled
                });
            }
        }

        const record = this.props.recordsState.record;
        if (prevRecord != null &&
            record != null) {

            if (prevRecord.id !== record.id &&
                this.state.assignedName !== unassigned) {

                this.setState({
                    assignedName: unassigned
                });
            }

            const recGeneral = record.record;
            if (recGeneral != null &&
                recGeneral.mdOverreadAssignedId != null &&
                recGeneral.mdOverreadAssignedId !== "") {

                const overreadAccount = this.props.accountsState.account;
                if (overreadAccount != null &&
                    overreadAccount.id === recGeneral.mdOverreadAssignedId &&
                    this.state.assignedName === unassigned) {

                    const name = this.formatPhysicianName(overreadAccount);
                    this.setState({
                        assignedName: name,
                        disabled: true
                    });
                }
                else if (!this.state.overreadFetched &&
                    !this.props.accountsState.fetching) {

                    this.props.accountsDispatch.getById(recGeneral.mdOverreadAssignedId);
                    this.setState({
                        overreadFetched: true
                    });
                }
            }
            else if (this.state.assignedName !== unassigned) {

                this.setState({
                    assignedName: unassigned
                });
            }
        }
    }

    formatPhysicianName(physician) {
        return `${physician.firstName} ${physician.lastName} (${physician.userName})`;
    }

    getAssignedList() {
        const allPhysicians = this.props.accountsState.allPhysicians;
        var physicians = null;

        if (allPhysicians != null &&
            allPhysicians.slice != null) {
            physicians = allPhysicians.slice();
        }
        else {
            physicians = [];
        }

        const items = physicians.map(physician => {
            const name = this.formatPhysicianName(physician);
            return <DropdownItem key={physician.id} onClick={this.handleAssigned.bind(this, physician.id, name)}>{name}</DropdownItem>;
        });

        return <DropdownMenu>{items}</DropdownMenu>;
    }

    handleAssigned(value, name) {
        const record = this.props.recordsState.record;
        const recGeneral = record.record;
        const update = record.mdOverreadAssignedId !== value;

        if (update &&
            recGeneral != null) {
            recGeneral.mdOverreadAssignedId = value;
            if (recGeneral.id == null ||
                recGeneral.id === "") {
                this.props.recordsDispatch.set(record);
            }
            else {
                this.props.recordsDispatch.updateRecordMdOverreadAssigned();
            }

            var disabled = this.state.disabled;
            if (!this.state.createRecord) {
                disabled = true;
            }
            this.setState({
                assignedName: name,
                disabled: disabled
            });
        }
    }

    initialize() {
        if (!this.state.disabled &&
            !this.state.physiciansFetched &&
            !this.props.accountsState.fetching) {

            this.props.accountsDispatch.getAllPhysicians();
            this.setState({
                physiciansFetched: true
            });
        }
    }

    render() {
        var assignedName = this.state.assignedName;
        const assignedList = this.getAssignedList();
        const dropdownId = "assignedDropdown";
        const dropdownOpen = this.state.dropdownOpen;

        return (
            <FormGroup>
                <Label for={dropdownId}>Assigned to MD:</Label>
                <Dropdown id={dropdownId} isOpen={dropdownOpen} toggle={() => this.setState({ dropdownOpen: !dropdownOpen })}>
                    <DropdownToggle caret className="dropdown-hcs" disabled={this.state.disabled}>{assignedName}</DropdownToggle>
                    {assignedList}
                </Dropdown>
            </FormGroup>
        );
    }
}

export default connect(
    state => ({
        accountsState: state.accounts,
        recordsState: state.records
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch)
    })
)(MdOverreadAssigned);



// WEBPACK FOOTER //
// ./src/components/MdOverreadAssigned.js